import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { ReceiptTransactionSummary } from "@qgiv/core-donor";
import { selectReceipt } from "../../../redux/slices/receiptSlice";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";

const ConnectedReceiptTransactionSummary = ({ controlId }) => {
    const {
        ENUMS: { DefaultView },
    } = constants;
    const receipt = useSelector(selectReceipt);
    const { transaction } = receipt;
    const { date, id, tm_stamp } = transaction;
    const transactionDate = moment(date).format("MM/DD/YYYY");
    const transactionId = id;
    const transactionTmStamp = moment(tm_stamp).format("hh:mm A");
    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.STANDARD_REGISTRATION_RECEIPT,
            state,
        ),
    );

    const {
        options: { summaryLabel, transactionIDLabel, dateLabel },
    } = control;

    const receiptTransactionSummaryProps = {
        transactionDate,
        transactionId,
        transactionTmStamp,
        transactionSummaryLabel: summaryLabel,
        transactionIDLabel,
        dateLabel,
    };

    return <ReceiptTransactionSummary {...receiptTransactionSummaryProps} />;
};

ConnectedReceiptTransactionSummary.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ConnectedReceiptTransactionSummary;
